import request from '@/axios'

// 建筑树
export function getTree() {
    return request({
        url: '/pay/room/treeList',
        method: 'get',
    })
}
// 查询房间信息列表
export function getRoomList(data={}) {
    return request({
        url: '/pay/room/roomList',
        method: 'get',
        params: data
    })
}
// 拉闸合闸操作-控制
export function laZhaControl(data) {
    return request({
        url: '/base/room/control',
        method: 'post',
        data
    })
}
// 拉闸操作-开
export function laZhaOn(data) {
    return request({
        url: '/base/room/control-on',
        method: 'post',
        data
    })
}
// 拉闸操作-关
export function laZhaOff(data) {
    return request({
        url: '/base/room/control-off',
        method: 'post',
        data
    })
}
// 充值
export function addJe(data={}) {
    return request({
        url: '/recharge/apply',
        method: 'post',
        params: data
    })
}
// 新增区域、楼栋
export function addLd(data={}) {
    return request({
        url: '/base/room/location/save',
        method: 'post',
        data
    })
}
// 新增房间
export function addRoom(data={}) {
    return request({
        url: '/base/room/save',
        method: 'post',
        data
    })
}
// 修改区域、楼栋
export function updateLd(data={}) {
    return request({
        url: '/base/room/location/update',
        method: 'post',
        data
    })
}
// 修改房间
export function updateRoom(data={}) {
    return request({
        url: '/base/room/update',
        method: 'post',
        data
    })
}
// 删除区域、楼栋
export function delLd(id) {
    return request({
        url: '/base/room/location/delete/' + id,
        method: 'post'
    })
}
// 清空房间配额
export function clearPe(data=[]) {
    return request({
        url: '/pay/room/quota/clear',
        method: 'post',
        data
    })
}
// 查询个人信息
export function getPersonList(data={}) {
    return request({
        url: '/pay/room/personList',
        method: 'get',
        params: data
    })
}
// 个人信息导出
export function get_person_export(data={}) {
    return request({
        url: '/pay/room/person/export',
        method: 'get',
        params: data
    })
}
// 房间交易报表导出
export function get_room_export(data={}) {
    return request({
        url: '/pay/room//elec/daily/export',
        method: 'get',
        params: data
    })
}
// 人交易报表导出
export function get_stu_export(data={}) {
    return request({
        url: '/pay/record/export',
        method: 'get',
        params: data
    })
}
// 查询交易明细
export function getMomentList(data={}) {
    return request({
        url: '/pay/room/roomRecord',
        method: 'get',
        params: data
    })
}
// 发放补贴
export function addButie(data={}) {
    return request({
        url: '/room/quota/recharge',
        method: 'post',
        data
    })
}
// 扣除补贴
export function delButie(data={}) {
    return request({
        url: '/room/quota/deduct',
        method: 'post',
        data
    })
}
// 管理员充值房间余额
export function addYe(data={}) {
    return request({
        url: '/room/account/recharge',
        method: 'post',
        data
    })
}
// 管理员扣除房间余额
export function delYe(data={}) {
    return request({
        url: '/room/account/deduct',
        method: 'post',
        data
    })
}
// 房间报表——房间充值记录
export function getczList(data={}) {
    return request({
        url: '/room/record/payorder/list',
        method: 'get',
        params: data
    })
}
// 房间报表——房间充值记录-导出
export function exportCzList(data={}) {
    return request({
        url: '/room/record/payorder/export',
        method: 'get',
        params: data
    })
}
// 房间报表——查询房间交易明细
export function getRoomtList(data={}) {
    return request({
        url: '/pay/room/elecDaily',
        method: 'get',
        params: data
    })
}
// 房间报表——查询房间交易明细-导出
export function exportRoomtList(data={}) {
    return request({
        url: '/pay/room/roomRecord/export',
        method: 'get',
        params: data
    })
}
// 人员报表——查询个人交易明细
export function getStutList(data={}) {
    return request({
        url: '/pay/record/list',
        method: 'get',
        params: data
    })
}
// 查询个人临时住宿
export function getLinshi(data={}) {
    return request({
        url: `/pay/room/personVacList`,
        method: 'get',
        params: data
    })
}
// 查询某个房间
export function getRoom(id) {
    return request({
        url: `/pay/room/info/${id}`,
        method: 'get',
        // params: data
    })
}
// 发放配额的报表
export function getPeBaobiao(data) {
    return request({
        url: `/pay/room/quotaTotal`,
        method: 'get',
        params: data
    })
}
// 发放配额的报表
export function getDailyTotal(data) {
    return request({
        url: `/pay/room/dailyTotal`,
        method: 'get',
        params: data
    })
}

// 查询未绑定人员列表
export function getUnbindPersonList(data) {
    return request({
        url: `/room/person/unbind/personlist`,
        method: 'get',
        params: data
    })
}
// 绑定宿舍
// 请求：[{"roomId": 1, "personId": 1},{"roomId": 1, "personId": 2}]
export function bdsh(data) {
    return request({
        url: `/room/person/bind`,
        method: 'post',
        data
    })
}
// 解绑宿舍
// 请求：[{"roomId": 1, "personId": 1},{"roomId": 1, "personId": 2}]
export function unbdsh(data) {
    return request({
        url: `/room/person/unbind`,
        method: 'post',
        data
    })
}

/* // 新增单价
export function addDj(data={}) {
    return request({
        url: `/pay/price/save`,
        method: 'post',
        data: data
    })
}
// 修改单价
export function updateDj(data={}) {
    return request({
        url: `/pay/price/update`,
        method: 'post',
        data: data
    })
}
// 删除单价
export function delDj(data={}) {
    return request({
        url: `/pay/price/delete`,
        method: 'post',
        data: data
    })
} */